/**
 * HoverGroup
 *
 * @selector [data-js-hovergroup]
 * @enabled true
 */
import BaseModule from '../../modules/BaseModule.js';

const DEFAULT_OPTIONS = {
    selector: '> *',
};

function getOptions(el) {
    const dataValue = el.dataset.jsHovergroup;

    if (dataValue === '' || dataValue === 'data-js-hovergroup' || dataValue == 'true') {
        return {};
    }

    try {
        // if its an object
        return JSON.parse(dataValue);
    } catch (e) {
        // if its just a string
        return {
            selector: dataValue,
        };
    }
}

export default class HoverGroup extends BaseModule {
    init(element) {
        this.el = element;

        this.options = Object.assign({}, DEFAULT_OPTIONS, getOptions(this.el));

        this.childs = element.querySelectorAll(`:scope ${this.options.selector}`);

        this.mouseEnterCallback = (e) => this.onItemMouseEnter(e);
        this.mouseLeaveCallback = (e) => this.onItemMouseLeave(e);

        this.childs.forEach((child) => {
            child.addEventListener('mouseenter', this.mouseEnterCallback);
            child.addEventListener('mouseleave', this.mouseLeaveCallback);
        });

        return this;
    }

    onItemMouseEnter(e) {
        e.target.classList.add('is-hovered');

        this.el.classList.add('is-hover-within');
    }

    onItemMouseLeave(e) {
        e.target.classList.remove('is-hovered');

        this.el.classList.remove('is-hover-within');
    }

    destroy() {
        this.childs.forEach((child) => {
            child.removeEventListener('mouseenter', this.mouseEnterCallback);
            child.removeEventListener('mouseleave', this.mouseLeaveCallback);
        });

        super.destroy();
    }
}
